'use strict';

var swig = require('swig-root'),
    isArray = require('lodash/isArray'),
    toString = Object.prototype.toString,
    keys = Object.keys,
    featureTag = require('./swig/tags/feature'),
    featureGroupTag = require('./swig/tags/group');

swig.setTag('feature', featureTag.parse, featureTag.compile, featureTag.ends, featureTag.blockLevel);
swig.setTag('feature_group', featureGroupTag.parse, featureGroupTag.compile, featureGroupTag.ends, featureGroupTag.blockLevel);

swig.setDefaults({
    locals: {
        gtxConstant: require('./gtx-constants'),
        dump: function () {
            var key;

            for (key in arguments) {
                if (arguments.hasOwnProperty(key)) {
                    console.log(arguments[key]);
                }
            }

            return '';
        }
    }
});

swig.setDefaultTZOffset(new Date().getTimezoneOffset());

swig.setFilter('length', function (value) {
    if (!value) {
        return 0;
    }

    if (toString.call(value) === '[object Array]') {
        return value.length;
    }

    if (typeof value === 'object') {
        return keys(value).length;
    }

    if (typeof value === 'string') {
        return value.length;
    }
});

swig.setFilter('json_encode', function (obj) {
    return JSON.stringify(obj);
});

swig.setFilter('slice', function (value, start, end) {

    if (value && typeof value.slice === 'function') {
        return value.slice(start, end);
    }

    return value;
});

swig.setFilter('trim', function (string) {
    if (typeof string === 'string') {
        return string.trim();
    }

    return string;
});

module.exports = swig;
